import React, {useId} from "react";
import {InfoIcon} from "./icons";
import "./InfoTip.css";

/**
 * A small info icon that explains something in a bubble on hover (or keyboard
 * focus, which is also what a tap does on a phone). For the kind of note that
 * would otherwise clutter the page.
 *
 * The icon is a button, so it can be reached with Tab, and it points at the
 * bubble with aria-describedby so screen readers read the text too.
 *
 * @param {{children: React.ReactNode, label?: string}} props
 */
const InfoTip = ({children, label = "Mais informações"}) => {
    const id = `info-tip-${useId().replace(/:/g, "")}`;

    return (
        <span className="info-tip">
            <button
                type="button"
                className="info-tip__button"
                aria-label={label}
                aria-describedby={id}
                // Escape hides it without having to move the mouse
                onKeyDown={(event) => {
                    if (event.key === "Escape") event.currentTarget.blur();
                }}
            >
                <InfoIcon />
            </button>
            <span role="tooltip" id={id} className="info-tip__bubble">
                {children}
            </span>
        </span>
    );
};

export default InfoTip;
